<template>
    <div class="iconSelector">
        <div class="iconContainer" v-for="icon in icons" :key="icon" @click="select(icon)"
            :class="{ selected: localValue == icon }">
            <component :is="icon"></component>
        </div>
    </div>
</template>

<script lang="ts">

import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import { Mixins, Prop, Watch } from 'vue-property-decorator';
import { UploadServices } from '@/services/UploadServices';
import WithModel from '@/mixins/withModel';

@Options({})
export default class iconSelector extends Mixins(WithModel) {

    declare localValue: string;
    icons: string[] = [];

    mounted(){
        const context = require.context('@/components/icons', true);

        this.icons = context.keys()
            .filter((key: string) => key.endsWith('.vue'))
            .map((key: string) => key.replace('./', '').replace('.vue', ''));

    }

    select(item: string){
        this.localValue = item;
        this.emitModel(item);
    }

}
</script>
<style scoped>

.iconSelector {
    display: flex;
    align-items: center;
}

.iconContainer {
    padding: 4px;
    cursor: pointer;
}

.iconContainer.selected {
    background-color: #228f59;
    color: white;
    border-radius: 4px;
}

</style>